module.exports = __webpack_public_path__ + "img/seled.dbc60781.png";